(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-bottom-sheet.js') >= 0) return;  svs.modules.push('/components/tipsen/co-op-play-marketplace/assets/javascripts/retailer-search-bottom-sheet.js');

'use strict';

const {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} = React;
const {
  ReactButton: Button,
  ReactBottomSheet
} = svs.ui;
const {
  Fieldset,
  RadioGroup,
  RadioButton
} = svs.ui.reactForm;
const {
  breakpoints,
  BREAKPOINT_MD,
  useMediaQuery
} = svs.components.lbUtils.useMediaQuery;
const {
  radioOptions,
  Range
} = svs.components.tipsen.utils.range;
const bottomSheetState = {
  CLOSED: 'closed'
};
const RetailerSearchBottomSheet = _ref => {
  let {
    currentRange,
    isVisible,
    onChange,
    onClose
  } = _ref;
  const showSettingsToTheRight = useMediaQuery(breakpoints.up(BREAKPOINT_MD));
  const bottomSheetPosition = showSettingsToTheRight ? 'right' : 'bottom';
  const [newRange, setNewRange] = useState(currentRange);
  const eventTypeRef = useRef(null);
  const radioRef = useRef(null);

  const onBottomSheetStateChange = state => {
    if (state.state === bottomSheetState.CLOSED) {
      if (newRange !== currentRange) {
        setNewRange(currentRange);
      }
      onClose === null || onClose === void 0 || onClose();
    }
  };

  const changeHandler = useCallback(value => {
    if (eventTypeRef.current === 'mousedown') {
      setNewRange(value);
    }
  }, [setNewRange]);

  const applyChanges = useCallback(() => {
    if (newRange !== currentRange) {
      onChange(newRange);
    }
    onClose === null || onClose === void 0 || onClose();
  }, [newRange, currentRange, onChange, onClose]);
  const memoRadioOptions = useMemo(() => radioOptions.map(_ref2 => {
    let {
      label,
      value
    } = _ref2;
    return React.createElement(RadioButton, {
      checked: newRange === value,
      className: "price-range-radio",
      key: value,
      name: "price-group",
      onChange: changeHandler,
      value: value
    }, React.createElement("span", {
      className: "f-300"
    }, label));
  }), [changeHandler, newRange]);
  useEffect(() => {
    const container = radioRef.current;

    const inputHandler = event => {
      eventTypeRef.current = event.type;

      switch (event.code) {
        case 'Escape':
          onClose === null || onClose === void 0 || onClose();
          break;
        case 'Enter':
        case 'Space':
          {
            const radio = event.target.closest('.price-range-radio');
            if (radio) {
              const value = Number(radio.getAttribute('value'));
              setNewRange(value);
            }
            break;
          }
        default:
      }
    };
    document.addEventListener('keydown', inputHandler);
    container === null || container === void 0 || container.addEventListener('mousedown', inputHandler);

    container === null || container === void 0 || container.querySelectorAll('.price-range-radio').forEach(radio => {
      const v = Number(radio.getAttribute('value'));
      const opt = radioOptions[v];
      if (opt) {
        radio.setAttribute('aria-label', opt.ariaLabel);
      }
    });
    return () => {
      document.removeEventListener('keydown', inputHandler);
      container === null || container === void 0 || container.removeEventListener('mousedown', inputHandler);
    };
  }, [onClose]);
  useEffect(() => {
    if (isVisible) {
      setNewRange(currentRange);
    }
  }, [currentRange, isVisible]);
  return React.createElement(ReactBottomSheet.BottomSheet, {
    behavior: "modal",
    className: "price-range-bottom-sheet",
    disablePageContentSpacing: true,
    headerTitle: "Filter f\xF6r andelspris",
    isFixed: true,
    isVisible: isVisible,
    onStateChange: onBottomSheetStateChange,
    position: bottomSheetPosition
  }, React.createElement("div", {
    className: "price-range-container",
    ref: radioRef
  }, React.createElement(Fieldset, null, React.createElement("legend", {
    className: "price-range-header"
  }, "V\xE4lj belopp"), React.createElement(RadioGroup, {
    className: "price-range-radio-group",
    gap: "12px",
    multipleLines: true
  }, memoRadioOptions))), React.createElement(ReactBottomSheet.BottomSheetFooter, {
    className: "price-range-bottom-sheet-footer"
  }, React.createElement(Button, {
    block: true,
    inverted: true,
    onClick: applyChanges
  }, "Klar")));
};
RetailerSearchBottomSheet.defaultProps = {
  isVisible: false
};
setGlobal('svs.components.tipsen.RetailerSearchBottomSheet', RetailerSearchBottomSheet);

 })(window);